import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء

// إعداد Axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getPlane = () => {
  const token = localStorage.getItem("authToken"); // بعد تسجيل الدخول
  return api.get(`get/plane?api_password=${API_PASSWORD}`, {
  
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    
  });
};

export const createPlane = (data) => {
  const token = localStorage.getItem("authToken");
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    // ❌ متبعتش image لو مش موجود أو مش ملف
    if (key === "image" && !(value instanceof File)) return;
    formData.append(key, value);
  });

  return api.post(
    `create/plane?api_password=${API_PASSWORD}`,
    formData,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "Content-Type": "multipart/form-data",
      },
    }
  );
};


export const updatePlane = (id, data) => {
  const token = localStorage.getItem("authToken");
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    // تجاهل الصورة لو مش ملف
    if (key === "image" && !(value instanceof File)) return;
    formData.append(key, value);
  });

  return api.post(
    `update/plane/${id}?api_password=${API_PASSWORD}`,
    formData,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "Content-Type": "multipart/form-data",
      },
    }
  );
};


export const getPlaneForUser = () => {
  const token = localStorage.getItem("authToken"); // بعد تسجيل الدخول
  return api.get(`get/plane?api_password=${API_PASSWORD}`, {
  
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    
  });
};
